import Input from "@/shared/form/input";
import { useTranslations } from "use-intl";
import Form from "@/shared/form/form";

export function Suggestion({
  setSuggestion,
  suggestion,
}: {
  suggestion: string;
  setSuggestion: (value: string) => void;
}) {
  const t = useTranslations("AI");

  return (
    <Form.Item layout={"vertical"} label={`${t("Suggestion")}:`}>
      <Input.TextArea
        value={suggestion}
        onChange={(value) => setSuggestion(value)}
        autoSize={{ minRows: 4, maxRows: 8 }}
        withoutAI
      />
    </Form.Item>
  );
}
